import React, { useRef, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import AdapterJalali from "@date-io/date-fns-jalali";
//استعلام و تشکیل پرونده
import DivisionCmp from "../../components/cards/DivisionCmp";
import AlertCmp from "../../components/alert/AlertCmp";
import ModalVerify from "../../components/modals/ModalVerify";
import { Formik } from "formik";
import {
  CustomerInfo,
  ExistingLoanRequest,
  GetCustomerRegistrationInfoRequest,
  GetCustomerRegistrationInfoResponse,
  LoanTemplateInfo,
  RegisterLoanBySupplierRequest,
  RegisterLoanBySupplierResponse,
} from "../../models/loan.model";
import {
  getCustomerRegistrationInfo,
  registerLoanBySupplier,
} from "../../services/loan.service";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Button } from "@material-ui/core";
import ModalCmp from "../../components/modals/ModalCmp";
import {
  NATIONAL_CODE,
  CUSTOMER_INFO,
  HAS_REGISTER_REQUEST,
  LOAN_ID,
  LOAN_TEMPLATE_INFOS,
  REFERENCE_KEY,
  SUPPLIER_CREDIT,
  IS_CANCELABLE,
  INSTALLMENT_COUNT,
  IS_EDITABLE,
  EXISTING_LOANREQUEST,
  INSTALLMENT_STEP,
  CUSTOMER_BIRTHDATE,
  CUSTOMER_MOBILENUMBER,
  LOAN_AMOUNT,
  POSTAL_CODE,
  INQUIRY_OTP_REF_KEY,
  TEXT_DROPDOWN,
} from "../../config/cacheKey";
import { GetSupplierCredit as getSupplierCredit } from "../../services/supplier.service";
import {
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { getTokenClaims } from "../../services/auth.service";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import DropdownCmp from "../../components/dropdown/DropdownCmp";
import InputIcon from "react-multi-date-picker/components/input_icon";
import rtlPlugin from "stylis-plugin-rtl";
import { column, prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PriceFeildComponent from "../../components/priceFeild/priceFeildComponent";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import * as Yup from "yup";
import { template } from "lodash";
import { HandleNext } from "../../models/sharedFunctions";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Item } from "react-bootstrap/lib/Breadcrumb";
import { any, array } from "prop-types";
import CardHintCmp from "../../components/cardHint/cardHintCmp";
import ModalinquiryOtp from "../../components/modals/ModalOtp";
import DropdownCmp2 from "../../components/dropdown/DropdownCmp2";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const nationalCodeHandleKeyDown = (event: any) => {
  var key = event.keyCode ? event.keyCode : event.which;

  if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
    event.preventDefault();
  }
  if (
    event.target.value.length >= yupNationalCodeMax &&
    key != 8 &&
    key != 46
  ) {
    event.preventDefault();
  }
};

const yupNationalCodeMax = 10;
const yupMobileMax = 11;

function RegisterNewRequest_(
  // { handelDisplayFacility }: any,
  { handleNext }: HandleNext
) {
  const [selectedCount, setSelectedPart] = React.useState();
  const queryClient = useQueryClient();
  const nationalcode = queryClient.getQueryData<string>(NATIONAL_CODE);
  const customer = queryClient.getQueryData<CustomerInfo>(CUSTOMER_INFO);
  const hasRegisterRequest = queryClient.getQueryData(HAS_REGISTER_REQUEST);
  const loan_id = queryClient.getQueryData<Number | undefined>(LOAN_ID);
  const finalLoanAmount = queryClient.getQueryData<ExistingLoanRequest>(
    EXISTING_LOANREQUEST
  );
  const loanTemplateInfos = queryClient.getQueryData<LoanTemplateInfo[]>(
    LOAN_TEMPLATE_INFOS
  );
  const [openValidationModel, setOpenValidationModel] = React.useState(false);
  const [openModalOtp, setOpenModalOtp] = React.useState(false);
  const [validationMessages, setValidationMessages] = React.useState<string[]>(
    []
  );
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);
  const [submitFlag, setSubmitFlag] = React.useState<boolean>(true);
  const [customerInfo, setCustomerInfo] = React.useState<CustomerInfo>(
    (): CustomerInfo => {
      let customerInfo = new CustomerInfo();
      return customerInfo;
    }
  );
  // const { data: supplierCredit } = useQuery<number>(
  //   SUPPLIER_CREDIT,
  //   (): Promise<number> => {
  //     return getSupplierCredit({ loanTemplateId: 6 });
  //   }
  // );

  const CustomerRegistrationInfo = useMutation(getCustomerRegistrationInfo, {
    onSuccess: (data: GetCustomerRegistrationInfoResponse) => {
      queryClient.setQueryData(HAS_REGISTER_REQUEST, data.hasRegisterRequest);
      queryClient.setQueryData(IS_EDITABLE, data.isEditable);
      queryClient.setQueryData(IS_CANCELABLE, data.isCancelable);
      queryClient.setQueryData(CUSTOMER_INFO, data.customerInfo);
      queryClient.setQueryData(LOAN_TEMPLATE_INFOS, data.loanTemplateInfos);
      queryClient.setQueryData(EXISTING_LOANREQUEST, data.existingLoanRequest);
    },
  });
  const valuesNationalCode = new GetCustomerRegistrationInfoRequest();

  valuesNationalCode.nationalCode = queryClient.getQueryData<string>(
    NATIONAL_CODE
  );

  const registerLoanBySupplierMutation = useMutation(registerLoanBySupplier, {
    onSuccess: (data: RegisterLoanBySupplierResponse) => {
      setOpenValidationModel(false);
      setOpenVerifyModal(false);
      setOpenModalOtp(false);
      if (data) {
        if (!data.isValid) {
          setSubmitFlag(true);
          setOpenValidationModel(true);
          setValidationMessages(data.validationIssues);
        } else {
          if (data.inquiryOtpRequired === true) {
            setSubmitFlag(true);
            queryClient.setQueryData(
              INQUIRY_OTP_REF_KEY,
              data.inquiryOtpRefKey
            );
            setOpenModalOtp(true);
          } else {
            setCustomerInfo(data.customerInfo);
            queryClient.setQueryData(REFERENCE_KEY, data.referenceKey);
            setOpenModalOtp(false);
            getCustomerRegistrationInfo(valuesNationalCode).then((data) => {
              queryClient.setQueryData(
                HAS_REGISTER_REQUEST,
                data.hasRegisterRequest
              );
              queryClient.setQueryData(IS_EDITABLE, data.isEditable);
              queryClient.setQueryData(IS_CANCELABLE, data.isCancelable);
              queryClient.setQueryData(CUSTOMER_INFO, data.customerInfo);
              queryClient.setQueryData(
                LOAN_TEMPLATE_INFOS,
                data.loanTemplateInfos
              );
              queryClient.setQueryData(
                EXISTING_LOANREQUEST,
                data.existingLoanRequest
              );
              handleNext();
            });
          }
          // CustomerRegistrationInfo.mutate(valuesNationalCode);
        }
      } else {
        setSubmitFlag(true);
      }
    },
    onError: () => {
      setSubmitFlag(true);
    },
  });

  //const yesterday=new Date(Date.now()-86400000).toDateString();

  const currentSelection = (e: any) => {
    setSelectedPart(
      e.target.value.substring(e.target.selectionStart, e.target.selectionEnd)
        .length
    );
  };
  const mobileNumberCodeHandleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;

    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
    if (
      event.target.value.length >= yupMobileMax &&
      key != 8 &&
      key != 46 &&
      selectedCount === 0
    ) {
      event.preventDefault();
    }
  };
  let pricePersian: any;
  const customerinformarion = customer;
  const loanTemplateInfosinformarion = loanTemplateInfos;
  /*filter*/

  // loanTemplateInfosinformarion?.filter((item: any) => item.id == loan_id).map( (item: any, index: number, array: any) =>{

  const listloan = loanTemplateInfosinformarion
    ?.filter((item: any) => item.id == loan_id)
    .map((item: any, index: number, array: any) => {
      return item.maxAmount;
    });

  const step = loanTemplateInfosinformarion
    ?.filter((item: any) => item.id == loan_id)
    .map((item: any, index: number, array: any) => {
      return item.installmentCount;
    });
  const count = loanTemplateInfosinformarion
    ?.filter((item: any) => item.id == loan_id)
    .map((item: any, index: number, array: any) => {
      return item.stepSpaceByMonth;
    });

  let minLoanAmount = loanTemplateInfosinformarion?.filter(
    (item) => item.id == loan_id
  )[0]?.minAmount;
  let maxLoanAmount = loanTemplateInfosinformarion?.filter(
    (item) => item.id == loan_id
  )[0]?.maxAmount;

  if (typeof minLoanAmount === "undefined") {
    minLoanAmount = 0;
  }
  if (typeof maxLoanAmount === "undefined") {
    maxLoanAmount = 0;
  }

  function parseStringNumber(value: number, originalValue: string) {
    const parsedVal = Number(String(originalValue).replace(/,/g, ""));
    return parsedVal;
  }
  const validationSchema = Yup.object().shape({
    // customerNationalCode: Yup.string().required("کد ملی اجباری می باشد").matches(/^[0-9]+$/, "شماره ملی فقط عدد می باشد").min(yupNationalCodeMax, "شماره ملی ده رقم است").max(yupNationalCodeMax, "شماره ملی فقط ده عدد است"),
    customerMobileNumber: Yup.string()
      .required("فیلد اجباری می باشد")
      .matches(/^[0-9]+$/, "شماره موبایل فقط عدد می باشد")
      .min(yupMobileMax, "شماره موبایل یازده رقم است")
      .max(yupMobileMax, "شماره موبایل یازده رقم است"),
    minAmount: Yup.number(),
    maxAmount: Yup.number(),
    loanAmount: Yup.number()
      .integer()
      .transform(parseStringNumber)
      .required("فیلد اجباری است.")
      .max(maxLoanAmount, "از بازه مشخص شده بیشتر است")
      .min(minLoanAmount, "از بازه مشخص شده کمتر است"),
    postalCode: Yup.string().required("فیلد اجباری است."),
    //customerBirthDate: Yup.string().required("فیلد اجباری است.")//.notOneOf([Yup.ref(yesterday)],'تاریخ اشتباه است')
  });

  let installmentCount = 0;
  let stepSpaceByMonth = 0;
  const installmentStep = loanTemplateInfosinformarion
    ?.filter((item) => item.id == loan_id)
    .map((item: any, index: number) => {
      //return item.installmentStep;
      return item.installmentStep?.map((items: any, index: string) => {
        // installmentCount = items.installmentCount;
        // stepSpaceByMonth = items.stepSpaceByMonth;
        return {
          id: items.key,
          text:
            "فاصله اقساط: " +
            String(items.stepSpaceByMonth) +
            " ماه - تعداد اقساط: " +
            String(items.installmentCount),
        };
      });
    });

  const optionss = installmentStep![0];
  const [itemSelected, setItemSelected] = useState<string>("tt");

  useEffect(() => {
    const textDROPDOWN = queryClient.getQueryData<string>(TEXT_DROPDOWN);
    if (textDROPDOWN && !hasRegisterRequest) {
      setItemSelected(textDROPDOWN);
    } else {
      setItemSelected(optionss[0].text);
    }
  }, []);

  //let selectedItemId;
  const handleSelectedDrop = (e: any) => {
    e.preventDefault();
    //selectedItemId=e.target.value;
    // let test = optionss.find((item: any) => item.text === e.target.value);
    setItemSelected(e.target.value);
  };

  // const getSpace =(id :number)=>{
  //   installmentStep?.filter((item:any) => item.id == id )  .map(
  //     (item: any, index: number) => {
  //     return item.;

  //   })
  // }
  // const optionss = installmentStep?.map((item:any,index:number)=>{
  //
  //   return {
  //     item
  //   }
  // });

  let LoanAmountt: any;

  if (finalLoanAmount === null) {
    LoanAmountt = null;
  } else {
    LoanAmountt = finalLoanAmount?.finalLoanAmount.toLocaleString();
  }

  let loanTemplateId = customerinformarion?.id;
  let customerNationalCode = customerinformarion?.nationalCode;
  let customerBirthDate = customerinformarion?.birthDate;
  let customerBirthDate_string = String(customerinformarion?.birthDate);
  let customerMobileNumber = customerinformarion?.cellPhone;
  let loanAmount = LoanAmountt; //listloan;
  let postalCode = customerinformarion?.postalCode;

  // let setstep = installmentStep;

  const [birthDate, setBirthDate] = React.useState<Date | undefined>(
    new Date(customerBirthDate_string)
  );

  let initialValues = new RegisterLoanBySupplierRequest();
  initialValues = {
    loanTemplateId: loan_id,
    customerNationalCode: customerNationalCode,
    customerBirthDate: customerBirthDate,
    customerMobileNumber: customerMobileNumber,
    loanAmount: loanAmount?.toLocaleString(),
    postalCode: postalCode,
    installmentCount: installmentCount,
    installmentStepSpace: stepSpaceByMonth,
  };
  const infocustmer = (
    <>
      کد ملی: <b>{nationalcode}</b>
      {"  "}
      {customer ? (
        <>
          &ensp; نام و نام خانوادگی:{" "}
          <b>{customer?.firstName + " " + customer?.lastName}</b>{" "}
        </>
      ) : (
        ""
      )}
    </>
  );
  return (
    <Box sx={{ flexGrow: 1 }}>
      <div style={{ padding: "40px", paddingBottom: "0px" }}>
        <CardHintCmp
          icon={<AccountCircleIcon sx={{ color: "#9AAFC4", fontSize: 30 }} />}
          title={
            <>
              {" "}
              کد ملی: <b>{nationalcode}</b>
              {"  "}
              {customer ? (
                <>
                  &ensp; نام و نام خانوادگی:{" "}
                  <b>{customer?.firstName + " " + customer?.lastName}</b>{" "}
                </>
              ) : (
                ""
              )}
            </>
          }
        />
        <div style={{ paddingTop: "10px" }}>
          <CardHintCmp
            icon={
              <ReportProblemOutlinedIcon
                sx={{ color: "#9AAFC4", fontSize: 25 }}
              />
            }
            title=" با فشردن دکمه استعلام و تشکیل پرونده اطلاعات هویتی، سابقه چک برگشتی، معوقات بانکی و کد پستی متقاضی از سامانه های مرتبط استعلام میگردد."
          />
        </div>
      </div>
      <Formik
        initialValues={initialValues}
        validateOnMount={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          if (submitFlag) {
            setSubmitFlag(false);
            values.customerBirthDate = convertToLocalDateTime(
              Number(birthDate)!
            );
            values.loanAmount = Number(
              String(values.loanAmount).replace(/,/g, "")
            );
            if (itemSelected != null) {
              queryClient.setQueryData(TEXT_DROPDOWN, itemSelected);
              const splits = itemSelected.split("-", 2);
              const countInstallment = splits[0].match(/\d+/g);
              const spaceInstallment = splits[1].match(/\d+/g);
              if (countInstallment != null && spaceInstallment != null) {
                values.installmentCount = Number(spaceInstallment[0]);
                values.installmentStepSpace = Number(countInstallment[0]);
              }
            } else {
            }

            const mina = installmentStep
              ?.filter((item) => item.id == values.installmentCount)
              .map((items: any, index: number) => {
                return items;
              });
            // values.installmentCount = Number(spaceInstallment[0]);
            // values.installmentStepSpace = stepSpaceByMonth;
            registerLoanBySupplierMutation.mutate(values);
            if (!values.customerNationalCode) {
              values.customerNationalCode = valuesNationalCode.nationalCode = queryClient.getQueryData<
                string
              >(NATIONAL_CODE);
            }

            queryClient.setQueryData(
              INSTALLMENT_COUNT,
              values.installmentCount
            );
            queryClient.setQueryData(
              INSTALLMENT_STEP,
              values.installmentStepSpace
            );
            queryClient.setQueryData(
              CUSTOMER_BIRTHDATE,
              values.customerBirthDate
            );
            queryClient.setQueryData(
              CUSTOMER_MOBILENUMBER,
              values.customerMobileNumber
            );
            queryClient.setQueryData(LOAN_AMOUNT, values.loanAmount);
            queryClient.setQueryData(POSTAL_CODE, values.postalCode);
          }
        }}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          errors,
          touched,
          handleBlur,
        }) => (
          <form
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          >
            <div>
              <Grid
                container
                spacing={2}
                style={{ padding: "40px", paddingLeft: "50px" }}
              >
                <Grid
                  className={`${
                    hasRegisterRequest ? "pointerEventsnone" : ""
                  } row`}
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                >
                  <Grid item xs={3}>
                    <MaterialTextFieldComponent
                      helperText={
                        touched.customerMobileNumber
                          ? errors.customerMobileNumber
                          : ""
                      } //!touched.customerMobileNumber
                      error={
                        touched.customerMobileNumber &&
                        Boolean(errors.customerMobileNumber)
                      } //!touched.customerMobileNumber
                      placeHolder={"شماره موبایل "}
                      label={"*شماره موبایل "}
                      required={true}
                      value={values.customerMobileNumber}
                      onChange={handleChange}
                      name="customerMobileNumber"
                      id="customerMobileNumber"
                      onKeyDown={mobileNumberCodeHandleKeyDown}
                      onSelect={currentSelection}
                      onBlur={handleBlur}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        value={birthDate}
                        label={"*تاریخ تولد"}
                        //  helperText={IsshowInputErrors ? RequiredField : ""}
                        // error={IsshowInputErrors}
                        onChange={(newValue: any) => {
                          setBirthDate(newValue);
                        }}
                        range={false}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <MaterialTextFieldComponent
                      helperText={touched.postalCode ? errors.postalCode : ""} //!touched.customerMobileNumber
                      error={touched.postalCode && Boolean(errors.postalCode)}
                      placeHolder={"کدپستی"}
                      label={"*کدپستی "}
                      required={true}
                      value={values.postalCode}
                      onChange={handleChange}
                      name="postalCode"
                      id="postalCode"
                      onBlur={handleBlur}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <DropdownCmp
                          onChange={handleSelectedDrop}
                          value={itemSelected}
                          label={"*تعداد اقساط"}
                          options={optionss}
                          name="installmentCount"
                          id="installmentCount"
                        />
                      </ThemeProvider>
                    </CacheProvider>
                  </Grid>
                </Grid>
                <br />
                <Grid
                  className="row"
                  container
                  // spacing={1}
                  // xs={6}
                  style={{ marginTop: "10px" }}
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                >
                  <Grid item xs={3}>
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <PriceFeildComponent
                          autoFocus={true}
                          helperText={
                            touched.loanAmount ? errors.loanAmount : ""
                          }
                          error={
                            touched.loanAmount && Boolean(errors.loanAmount)
                          }
                          label={"*مبلغ تسهیلات (ریال)"}
                          placeHolder={"* (ریال)مبلغ تسهیلات "}
                          required={true}
                          value={loanAmount} //{LoanAmountt}
                          name="loanAmount"
                          id="loanAmount"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          // onKeyDown={handleKeyDown}
                        />
                      </ThemeProvider>
                    </CacheProvider>
                    <br />
                    <span>{pricePersian}</span>
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      type="submit"
                      disabled={Object.keys(errors).length > 0 && submitFlag}
                      className={`${
                        Object.keys(errors).length > 0
                          ? "btnForm disabledBtn  "
                          : "btnForm SuccessDefault"
                      }`}
                      // style={{ width: "120px" }}
                      fullWidth
                    >
                      استعلام و تشکیل پرونده
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </form>
        )}
      </Formik>
      <ModalCmp
        openModel={openValidationModel}
        validationMessages={validationMessages}
        firstPartOfTitle=" درخواست تسهیلات به دلایل زیر"
        boldTitle="پذیرفته"
        secondPartOfTitle="نشد:"
      />
      <ModalVerify
        // handelDisplayFacility={handelDisplayFacility}
        openModel={openVerifyModal}
        customerInfo={customerInfo}
      />
      <ModalinquiryOtp openModel={openModalOtp} />
    </Box>
  );
}
export default function RegisterNewRequest(
  // { handelDisplayFacility }: any,
  { handleNext }: HandleNext
) {
  const child = (
    <RegisterNewRequest_
      // handelDisplayFacility={handelDisplayFacility}
      handleNext={handleNext}
    />
  );
  return <DivisionCmp child={child} title="استعلام و تشکیل پرونده" />;
}

const onKeyDown = (e: any) => {
  e.preventDefault();
};
